import { CanvasActionTypes } from '@storeOld/reducers/canvas/canvas'
import type React from 'react'
import { useDispatch } from 'react-redux'

const useSelection = (nodeId?: string) => {
  const dispatch = useDispatch()

  const clearSelection = () => {
    dispatch({
      type: CanvasActionTypes.SELECT_NODES,
      payload: [],
    })
  }

  const clearSelectionForOthers = (nodeId: string) => {
    dispatch({
      type: CanvasActionTypes.SELECT_NODES,
      payload: [nodeId],
    })
  }

  const selectNode = (e: React.MouseEvent) => {
    if (!e.shiftKey) {
      dispatch({
        type: CanvasActionTypes.SELECT_NODES,
        payload: [nodeId || ''],
      })

      return
    }

    dispatch({
      type: CanvasActionTypes.ADD_SELECTED_NODE,
      payload: nodeId || '',
    })
  }

  return {
    clearSelection,
    clearSelectionForOthers,
    selectNode,
  }
}

export default useSelection
